import { Injectable, inject } from '@angular/core';
import { ApplicationSettingsService } from '@app/client/api/applicationSettings.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface AppSettings {
  appTitle: string;
  googleMapsApiKey: string;
  logoHtmlLight: string;
  logoHtmlDark: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  private applicationSettingsService = inject(ApplicationSettingsService);
  private settings$ = new BehaviorSubject<AppSettings | null>(null);

  getSettings(): Observable<AppSettings | null> {
    return this.settings$.asObservable();
  }

  loadSettings(): Observable<AppSettings> {
    return this.applicationSettingsService.getAppSettings().pipe(tap((settings) => this.settings$.next(settings)));
  }

  getAppTitle(): string {
    return this.settings$.value?.appTitle || 'FullstackCRM';
  }

  getGoogleMapsApiKey(): string {
    return this.settings$.value?.googleMapsApiKey || '';
  }

  getLogoHtmlLight(): string {
    return this.settings$.value?.logoHtmlLight || this.getDefaultLogoHtml();
  }

  getLogoHtmlDark(): string {
    return this.settings$.value?.logoHtmlDark || this.getDefaultLogoHtml();
  }

  private getDefaultLogoHtml(): string {
    return `
      <img src="assets/img/logo_color.png" alt="logo" style="height: 2rem;" />
      <span style="font-weight: bold; margin-left: 0.5rem;">Nest</span>
      <span style="color: #facc15; font-weight: bold;">Up</span>
    `;
  }
}
